import { currencyFormat } from "lib/CurrencyFormatter"
import React from "react"

interface BudgetCopyProps {
  budget: number
  monthlyPayment: number
}

const WithinBudgetCopy = ({ budget }: { budget: number }) => (
  <>
    The monthly cost for this mortgage is{" "}
    <strong>within your stated budget of £{currencyFormat(budget)}</strong>, ensuring the ongoing
    cost remains at a level you are comfortable with.
  </>
)
const ExceededBudgetCopy = ({ budget }: { budget: number }) => (
  <>
    Although the monthly payment is{" "}
    <strong>higher than your original budget of £{currencyFormat(budget)}</strong>, I’ve reviewed
    your income and outgoings and am satisfied it’s affordable, and you’re comfortable it fits
    within your finances.
  </>
)
export const BudgetCopy = ({ budget, monthlyPayment }: BudgetCopyProps) =>
  monthlyPayment > budget ? (
    <ExceededBudgetCopy budget={budget} />
  ) : (
    <WithinBudgetCopy budget={budget} />
  )
